// extracted by mini-css-extract-plugin
export var explainable = "_i1-a";
export var printerCard = "_i1-1";
export var printerCardConfigured = "_i1-2";
export var printerCardError = "_i1-3";
export var printerCardsContainer = "_i1-0";
export var printerIcon = "_i1-8";
export var printerIconConfigured = "_i1-5";
export var printerIconContainer = "_i1-4";
export var printerIconError = "_i1-6";
export var printerIconUnconfigured = "_i1-7";
export var workstationsTableCard = "_i1-9";